import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'app-action-card',
  templateUrl: './action-card.component.html',
  styleUrls: ['./action-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatIcon],
})
export class ActionCardComponent {
  @Input({ required: true }) title = ''
  @Input() description = ''
  @Input() icon = 'arrow_forward'
  @Input() route: unknown[] | string = []
  @Input() state: Record<string, unknown> | undefined = undefined
  @Input() variant: 'mint' | 'blush' | 'sand' | 'lavender' | 'neutral' = 'neutral'
  @Input() ariaLabel = ''
  @Input() layout: 'tile' | 'row' = 'tile'
  @Input() actionRoute: unknown[] | string | null = null
  @Input() actionState: Record<string, unknown> | undefined = undefined
  @Input() actionLabel = 'Open'
  @Input() actionAriaLabel = ''
  @Input() actionIcon = 'arrow_forward'
  @Input() disabled = false

  readonly action = output<void>()

  hasActionRoute(): boolean {
    return this.hasRouteValue(this.actionRoute) || this.hasRouteValue(this.route)
  }

  rowRoute(): unknown[] | string {
    return this.hasRouteValue(this.actionRoute) ? this.actionRoute as unknown[] | string : this.route
  }

  rowState(): Record<string, unknown> | undefined {
    return this.hasRouteValue(this.actionRoute) ? this.actionState : this.state
  }

  private hasRouteValue(value: unknown): boolean {
    return Array.isArray(value) ? value.length > 0 : typeof value === 'string' && value.length > 0
  }
}
